// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"ReportsTable_tableWrapper__1taOC","spinner":"ReportsTable_spinner__1_spJ"};